import { getAssistantId } from 'chatspot-core/assistants/getAssistantId';
import { httpClient } from '../../http/httpClient';

/** OpenAI creates threads when the first message is sent */
export const createSalesCopilotFirstMessageAndCreateThread = ({
  message
}) => {
  return httpClient.post(`hub/gpt/v1/threads`, {
    data: {
      openAiThreadCreationRequest: {
        messages: [{
          content: [{
            type: 'text',
            text: message
          }],
          role: 'user',
          attachments: []
        }]
      },
      assistantId: getAssistantId()
    }
  });
};
export const createSalesCopilotMessage = ({
  message,
  threadId
}) => {
  return httpClient.post(`hub/gpt/v1/threads/${threadId}/messages`, {
    data: {
      message: {
        content: [{
          type: 'text',
          text: message
        }],
        role: 'user',
        attachments: []
      },
      assistantId: getAssistantId()
    }
  });
};